import React, { useState } from "react";
import WithAuthLayout from "../withAuthLayout";
import ForgotPasswordEmail from "./forgotPasswordEmail";
import ForgotPasswordEmailSent from "./forgotPasswordEmailSent";

const ForgotPassword: React.FC = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");

  let content;
  switch (step) {
    case 1:
      content = (
        <ForgotPasswordEmail
          setStep={setStep}
          email={email}
          setEmail={setEmail}
        />
      );
      break;
    case 2:
      content = (
        <ForgotPasswordEmailSent setStep={setStep} email={email} />
      );
      break;
    default:
      content = (
        <ForgotPasswordEmail
          setStep={setStep}
          email={email}
          setEmail={setEmail}
        />
      );
      break;
  }

  return (
    <main className="d-flex align-items-center gap-5 justify-content-between">
      {content}
    </main>
  );
};

export default WithAuthLayout(ForgotPassword);
